const DrawerBookingEventForm = () =>
  import('@bookings/components/drawer-booking-event-form/drawer-booking-event-form.vue');
import { BookingEvent } from '@bookings/interfaces/booking-event';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import moment from 'moment';

@Component({
  name: 'bpc-event-conflicts',
  components: {
    'bpc-drawer-booking-event-form': DrawerBookingEventForm,
  },
})
export default class EventConflicts extends Vue {
  @Prop(Array) readonly conflicts: BookingEvent[];
  @Prop({ type: Number, default: 0 }) readonly deep: number;

  public showDrawerSection: boolean = false;
  public selectedEntity: BookingEvent = null;
  public i: number = 1;

  clickedOnConflict(conflict: BookingEvent) {
    console.log('clickedOnConflict', conflict);
    this.$bpcStorage.clear('orders');
    this.selectedEntity = conflict;
    // this.$bvModal.show('modal-resource-form');
    this.showDrawerSection = true;
  }

  get editModalTitle(): string {
    return `${this.$t('global.modals.edit')} ${this.$t('global.models.booking-event.name')}`;
  }

  onFormSaved($event: any = null) {
    this.showDrawerSection = false;
    this.$emit('conflict-saved', $event);
  }

  onFormClosed() {
    // this.$bvModal.hide('modal-resource-form');
    // this.$refs.provider.getEntities();
    this.showDrawerSection = false;
    this.i++;
  }

  formatDate(date): string {
    if (date) {
      return moment(String(date)).format('DD/MM/YYYY');
    }
    return '';
  }

  formatTime(time): string {
    if (time) {
      return time.substr(0, 5);
    }
    return '';
  }

  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
